"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestCaseValidationStatus = void 0;
var TestCaseValidationStatus;
(function (TestCaseValidationStatus) {
    TestCaseValidationStatus["PENDING"] = "Pending";
    TestCaseValidationStatus["VALIDATING"] = "Validating";
    TestCaseValidationStatus["VALID"] = "Valid";
    TestCaseValidationStatus["INVALID"] = "Invalid";
    TestCaseValidationStatus["INVALID_JSON"] = "Invalid JSON";
    TestCaseValidationStatus["NOT_COMPLETE"] = "Not Complete";
})(TestCaseValidationStatus = exports.TestCaseValidationStatus || (exports.TestCaseValidationStatus = {}));
